import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'

import { cn } from '../../lib/utils'

const calloutVariants = cva('rounded-lg border p-4', {
  variants: {
    variant: {
      neutral: 'border-border bg-card text-card-foreground',
      info: 'border-primary/30 bg-primary/5 text-foreground',
      warning: 'border-chart-4/40 bg-chart-4/10 text-foreground',
      success: 'border-chart-2/40 bg-chart-2/10 text-foreground',
      destructive: 'border-destructive/30 bg-destructive/10 text-foreground',
    },
  },
  defaultVariants: {
    variant: 'neutral',
  },
})

function Callout({
  className,
  variant,
  ...props
}: React.ComponentProps<'div'> & VariantProps<typeof calloutVariants>) {
  return <div data-slot="callout" className={cn(calloutVariants({ variant }), className)} {...props} />
}

export { Callout, calloutVariants }
